
import { Route, useRouteMatch, useParams } from 'react-router-dom';
import ContentTypes from '../components/contenttype/ContentTypes'
import EditContentType from '../components/contenttype/EditContentType'
import './contenttype/cct.css'

const Content = ({language, setBreadcrumbObject}) => {
    let { url } = useRouteMatch();
    let { contentTypeId } = useParams();

    return (
        <div id="cc_content" className="scrollable">
            <Route path={`${url}/:contentTypeId`}  exact strict>
                <EditContentType contentTypeId={contentTypeId} language={language} setBreadcrumbObject={setBreadcrumbObject} />
            </Route>
            <Route path={url} exact strict>
                <ContentTypes language={language} setBreadcrumbObject={setBreadcrumbObject} />
            </Route>
        </div>
    )
}

export default Content
